import { Component, h, Prop, Watch, Element } from '@stencil/core';
import { ActionTrackingEvent } from '@union-investment/tracking/src/events';
import { DEFAULT_TRACKING_DELAY, delayPageChange } from '../../global/utility/tracking-helpers';

export interface UiCmsContactChannelsEmailBody {
  buttonTitle: string;
  emailAddress: string;
  text: string;
  headline: string;
}

@Component({
  tag: 'ui-cms-contact-channels-email-sticky-toolbar',
  styleUrl: 'ui-cms-contact-channels-email-sticky-toolbar.scss',
})
export class UiCmsContactChannelsEmailStickyToolbar {
  @Element() el: HTMLUiCmsContactChannelsEmailStickyToolbarElement;

  @Prop({ mutable: true }) body: UiCmsContactChannelsEmailBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Watch('utilityBody')
  bodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  componentWillLoad() {
    this.bodyChangeHandler(this.utilityBody);
  }

  onLinkClick(event: Event, link: HTMLAnchorElement) {
    delayPageChange(DEFAULT_TRACKING_DELAY, event, link);
    const trackingEvent: ActionTrackingEvent = {
      eventInfo: {
        eventName: 'Contact Email via Sticky Toolbar',
        eventType: 'Action',
        eventCaller: this.el,
      },
      attributes: {
        elementType: 'Link',
        elementLabel: this.body.buttonTitle,
        externalTarget: this.body.emailAddress,
      },
      category: {
        area: 'Content',
      },
    };

    window.ui?.services?.tracking?.track(trackingEvent);
  }

  onWriteEmailClick(mail: string) {
    const trackingEvent: ActionTrackingEvent = {
      eventInfo: {
        eventName: 'Write Email via Sticky Toolbar',
        eventType: 'Action',
        eventCaller: this.el,
      },
      attributes: {
        elementType: 'Button',
        elementLabel: this.body.buttonTitle,
        target: mail,
      },
      category: {
        area: 'Sticky Toolbar',
      },
    };

    window.ui?.services?.tracking?.track(trackingEvent);
  }

  render() {
    const mail = `mailto:${this.body.emailAddress}`;

    return (
      <div class="channel-contactbox">
        {this.body.headline && <h3 class="sd-headline sd-headline--size-lg">{this.body.headline}</h3>}
        {this.body.text && <p class="sd-paragraph" innerHTML={this.body.text}></p>}
        <sd-link
          href={mail}
          onClick={(event: Event) => this.onLinkClick(event, event.currentTarget as HTMLAnchorElement)}
        >
          {this.body.emailAddress}
        </sd-link>
        <br />
        <sd-button href={mail} variant="cta" target="_blank" onClick={() => this.onWriteEmailClick(mail)}>
          {this.body.buttonTitle}
        </sd-button>
      </div>
    );
  }
}
